import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { QUERY_KEY } from '~common';
import { postRequest } from '~services';
import { VenueFilterListingResponse, VenuesRequestParams } from '~types';

export const useQueryGetVenuesWithFilter = (
  reqParams: VenuesRequestParams,
  options?: Omit<
    UseQueryOptions<
      VenueFilterListingResponse,
      AxiosError<Record<string, string>>,
      VenueFilterListingResponse,
      (QUERY_KEY | VenuesRequestParams)[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >,
) => {
  const getListVenueFilter = (): Promise<VenueFilterListingResponse> =>
    postRequest({
      path: `api/admin/venue/filter-list`,
      data: reqParams,
    }).then((res) => res.data);

  return useQuery(
    [QUERY_KEY.GET_LIST_VENUE_FILTER, reqParams],
    () => getListVenueFilter(),
    {
      ...options,
    },
  );
};
